import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

interface ISessionState {
  lastAuthOkAt: number | null; // epoch ms
  markAuthOk: () => void;
  clearAuthOk: () => void;

  // UI state: do NOT persist
  isSessionExpiredModalOpen: boolean;
  showSessionExpiredModal: () => void;
  hideSessionExpiredModal: () => void;

  // Derived decision
  shouldShowSessionExpiredModal: () => boolean;
}

export class SessionStore {
  static useSessionStore = create<ISessionState>()(
    devtools(
       persist(
        (set, get) => ({
          lastAuthOkAt: null,          
          markAuthOk: () => set({ lastAuthOkAt: Date.now() }),
          clearAuthOk: () => set({ lastAuthOkAt: null }),
  
          isSessionExpiredModalOpen: false,

          showSessionExpiredModal: () => {
            set({ isSessionExpiredModalOpen: true });
          },

          hideSessionExpiredModal: () => {
            set({ isSessionExpiredModalOpen: false });
          },

          // Show the modal on any 401 as long as the user was ever authenticated in this
          // browser. `clearAuthOk()` (called on logout) resets this to null, so post-logout
          // 401s don't trigger the modal.
          shouldShowSessionExpiredModal: () => {
              return get().lastAuthOkAt !== null;
          },

        }),
        { 
          name: "SessionStore", 
          // only persist what you need across reloads
          partialize: (s) => ({ lastAuthOkAt: s.lastAuthOkAt }),
        }
      ),
      { name: "SessionStore(devtools)" }
    )
  );
}

export default SessionStore;
